var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var fieldset = {
    alignItems: 'start',
    border: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    margin: 0,
    padding: "".concat(8 - 1, "px ").concat(8, "px 0 0"),
};
export var label = {
    alignItems: 'start',
    boxSizing: 'border-box',
    color: '#222222',
    display: 'flex',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 16 + 'px',
    marginBottom: 16,
    paddingRight: 12,
    ':disabled': {
        color: '#cccccc',
    },
};
export var labelSingle = __assign(__assign({}, label), { display: 'inline-block', marginBottom: 0, paddingRight: 0, width: 'auto' });
/** @ignore */
export var labelWidth = function (column) { return ({
    width: column === undefined ? 'auto' : Math.floor(100 / column) + '%',
}); };
export var col1 = labelWidth(1);
export var col2 = labelWidth(2);
export var col3 = labelWidth(3);
export var col4 = labelWidth(4);
export var col6 = labelWidth(6);
export var innerWrapper = {
    display: 'flex',
};
export var innerWrapperChecked = __assign({}, innerWrapper);
export var inputWrapper = {
    marginRight: 6,
};
export var input = {
    ':disabled': {
        cursor: 'not-allowed',
    },
};
export var error = {
    outline: "1px solid ".concat('#c8102e'),
    outlineOffset: '1px',
};
export var textWrapperDisabled = {
    color: '#cccccc',
    cursor: 'not-allowed',
};
export var disabledHighlight = {
    backgroundColor: '#cccccc',
    color: '#ffffff',
};
